// extracted by mini-css-extract-plugin
export default {"wrapper":"styles-module--wrapper--5d687"};